import { put2 } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { RestaurantTable } from "@/shared/utils/interfaces";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

const useRestaurantTableUpdate = (restaurantId: number) => {
  const queryClient = useQueryClient();
  const branchId = useBranchId();
  const { t } = useTranslation("");
  const mutation = useMutation({
    onSuccess: () => {
      queryClient.refetchQueries({
        queryKey: ["restaurantMap", branchId, restaurantId],
        exact: true,
      });
    },
    mutationFn: (table: RestaurantTable) =>
      put2(
        `/internal/secure/pos/v1/tables/${branchId}/${restaurantId}/${table.item_id}`,
        { ...table, item_id: undefined }
      ),
  });
  return mutation;
};

export default useRestaurantTableUpdate;
